const styles = () => ({
  backgroundContentContainer: ({ backgroundContentContainer }) => ({
    backgroundColor: backgroundContentContainer,
  }),
});

export default styles;
